import React from 'react'
import RbacRoleModuleAccessList from '../../../components/rbac/role-module-access/RbacRoleModuleAccessList';

const RbacRoleModuleAccess = () => {
  return <RbacRoleModuleAccessList />
}

export default RbacRoleModuleAccess;
